import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", y = 40 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.1 }}
    transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1], delay }}
  >
    {children}
  </motion.div>
);

export const SectionHead = ({ idx, kicker, title, right }) => (
  <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-12 md:mb-16">
    <Reveal>
      <div className="f-mono text-xs tracking-[0.3em] text-[#FF2A2A] mb-4">({idx}) — {kicker}</div>
      <h2 className="f-disp uppercase text-6xl md:text-8xl leading-[0.85] text-[#F5F5F7]">{title}</h2>
    </Reveal>
    {right}
  </div>
);
